module.exports = __webpack_public_path__ + "static/media/book.7ecc845c.png";